<div class="flex justify-center pt-28 bg-[#DDE2E7] pb-12">
  <div class="max-w-[1330px] max-[1330px]:px-10 w-full gap-10 flex max-md:flex-col">
    <app-contact-us-section-component [subject]="subject()" class="!bg-[#DDE2E7] xl:w-1/2 pt-0 max-lg:px-2.5 max-lg:w-full"/>
    <div class="flex w-1/2 justify-end items-end max-lg:px-2.5 max-lg:w-full">
      <div class="bg-white max-w-[437px] w-full h-full max-h-[561px] flex justify-center flex-col items-center rounded-md p-5">
        <img class="max-w-[214px]  max-h-[214px] mb-5" src="assets/images/profile.png" alt="profile">
        <p class="text-xl font-tektur text-mainColor">Ivan Oleksii</p>
        <span class="text-base font-tektur text-[#919EAB] mb-10">Co-creator of Car for Ukraine</span>
        <span class="font-tektur text-mainColor" i18n>
          Thinking about donating a car, helping with spreading the word, or something else that will get us one step closer to our shared victory? Leave us a message, and we’ll get back to you within 24 hours!
        </span>
      </div>
    </div>
  </div>
</div>
<div>
  <img class="w-full" src="assets/images/about/group.png" alt="map">
</div>
